/*
 * Filtros de la lista de devoluciones.
 *
 * Contiene el componente genérico del buscadr. Se agregan selectores de opciones y un selector
 * de fecha.
 *
 * Created on Wed Apr 12 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>

    <!-- #region begin:title -->
    <b-form-row>
      <b-col cols="12">
        <h3>Devoluciones</h3>
      </b-col>
    </b-form-row>
    <!-- #endregion end:title -->

    <!-- #region begin:: List options -->
    <b-form-row>

      <!-- #region begin::Searcher -->
      <b-col
        md="2"
        class="my-50"
      >
        <BasicSearcher
          ref="basic-searcher"
          :callback="handleSearch"
          placeholder="Buscar devolución"
        />
      </b-col>
      <!-- #endregion end::Searcher -->

      <!-- #region::Status select filter -->
      <b-col
        md="2"
        class="my-50"
      >
        <v-select
          v-model="selectedRefundStatus"
          label="text"
          class="style-chooser"
          placeholder="Estatus"
          :options="getRefundsStatusList"
        />
      </b-col>
      <!-- #endregion::Status select filter -->

      <!-- #region::Required date filter -->
      <b-col
        md="2"
        class="my-50"
      >
        <b-form-datepicker
          id="transfer-datepicker"
          v-model="selectedTransferDate"
          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
          placeholder="Fecha de creación"
          local="es"
          reset-button
        />
      </b-col>
      <!-- #endregion::Required date filter -->

      <!-- #region::Destination location select filter -->
      <b-col
        v-if="!$ability.can('received', 'Devolution')"
        md="2"
        class="my-50"
      >
        <v-select
          v-model="selectedRefundLocation"
          label="text"
          class="style-chooser"
          placeholder="Ubicación"
          :options="getLocations"
        />
      </b-col>
      <!-- #endregion::Destination location select filter -->

      <!-- #region::Creators filter -->
      <b-col
        v-if="$ability.can('read creator', 'Devolution')"
        md="2"
        class="my-50"
      >
        <vue-autosuggest
          v-model="filteredCreator.name"
          :suggestions="creatorsOptions"
          :limit="5"
          :input-props="{
            id:'autosuggest__input2',
            class:'form-control',
            placeholder:'Buscar por creador'
          }"
          @input="onCreatorNameChange"
          @selected="onSelectedCreatorName"
        >
          <template slot-scope="{suggestion}">
            <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
          </template>
        </vue-autosuggest>
      </b-col>
      <!-- #endregion::Creators filter -->

      <!-- #region::Refund payment status filter -->
      <b-col
        md="2"
        class="my-50"
      >
        <v-select
          v-model="selectedRefundPaymentStatus"
          label="text"
          class="style-chooser"
          placeholder="Pago reembolso"
          :options="getRefundsPaymentsStatusList"
        />
      </b-col>
      <!-- #endregion::Refund payment status filter -->

      <!-- #region::Required date filter -->
      <b-col
        md="2"
        class="my-50"
      >
        <b-form-datepicker
          id="received-date-datepicker"
          v-model="selectedReceivedDate"
          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
          placeholder="Fecha de recibida"
          local="es"
          reset-button
        />
      </b-col>
      <!-- #endregion::Required date filter -->

      <!-- #region::Received date filter -->
      <b-col
        md="2"
        class="my-50"
      >
        <vue-monthly-picker
          v-model="selectedReceivedMonth"
          place-holder="Mes recibida"
          date-format="MMMM yyyy"
          :month-labels="monthLabels"
          :input-class="['month-picker-style']"
          :min="minDate"
        />
      </b-col>
      <!-- #endregion::Received date filter -->

      <!-- #region::ID sorter filter -->
      <b-col
        md="2"
        class="my-50"
      >
        <v-select
          v-model="selectedIdOption"
          label="text"
          class="style-chooser"
          placeholder="ID"
          :options="getIdOptions"
        >
          <template #option="{ text, icon }">
            <feather-icon
              :icon="icon"
              size="16"
              class="align-middle mr-50"
            />
            <span> {{ text }}</span>
          </template>
        </v-select>
      </b-col>
      <!-- #endregion::ID sorter filter -->

      <!-- #region::Order status select -->
      <b-col
        v-if="canShowCommissionStatusFilter"
        md="2"
        class="my-50"
      >
        <v-select
          v-model="selectedCommissionStatus"
          label="text"
          class="style-chooser"
          placeholder="Estatus de comisión"
          :options="getCommissionStatus"
        />
      </b-col>
      <!-- #endregion::Order status select -->

    </b-form-row>
    <!-- #endregion begin:: List options -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BCol, BFormRow, BFormDatepicker,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import VueMonthlyPicker from 'vue-monthly-picker'
import { VueAutosuggest } from 'vue-autosuggest'
import BasicSearcher from '@/components/forms/BasicSearcher.vue'

import monthLabels from '@/helpers/MonthLabels'

export default {
  components: {
    BCol,
    vSelect,
    BFormRow,
    BasicSearcher,
    VueAutosuggest,
    BFormDatepicker,
    VueMonthlyPicker,
  },
  data() {
    return {
      /**
       * For creator filter
       */
      creatorsOptions: [],
      selectedCreator: '',

      selectedIdOption: '',
      selectedTransferDate: '',
      selectedRefundStatus: '',
      selectedReceivedDate: '',
      selectedReceivedMonth: '',
      selectedRefundLocation: '',
      selectedCommissionStatus: '',
      selectedRefundPaymentStatus: '',

      monthLabels,
      /**
       * Set 2021 as min selectable date
       */
      minDate: this.$moment('2021-01-01'),
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    ...mapGetters({
      getIdOptions: 'quotes/getIdOptions',
      getLocations: 'transfers/getLocations',
      getCommissionStatus: 'refunds/getCommissionStatus',
      getCreatorsSuggests: 'refunds/getCreatorsSuggests',
      getRefundsStatusList: 'refunds/getRefundsStatusList',
      getRefundsPaymentsStatusList: 'refunds/getRefundsPaymentsStatusList',

      /**
       * Filtros globales
       */
      getFilteredSortBy: 'filters/getFilteredSortBy',
      getFilteredStatus: 'filters/getFilteredStatus',
      getFilteredCreator: 'filters/getFilteredCreator',
      getFilteredSearchTerm: 'filters/getFilteredSearchTerm',
      getFilteredReceivedDate: 'filters/getFilteredReceivedDate',
      getFilteredCreatedAtDate: 'filters/getFilteredCreatedAtDate',
      getFilteredReceivedMonth: 'filters/getFilteredReceivedMonth',
      getFilteredPiecesLocation: 'filters/getFilteredPiecesLocation',
      getFilteredCommissionStatus: 'filters/getFilteredCommissionStatus',
      getFilteredRefundPaymentStatus: 'filters/getFilteredRefundPaymentStatus',
    }),
    /**
     * Ordenamiento global (filtro en store)
     */
    filteredSortBy: {
      get() { return this.getFilteredSortBy },
    },
    /**
     * Filtro de estatus (filtro en store)
     */
    filteredStatus: {
      get() { return this.getFilteredStatus },
    },
    /**
     * Filtro de creador (filtro en store)
     */
    filteredCreator: {
      get() { return this.getFilteredCreator },
    },
    /**
     * Filtro de búsqueda (filtro en store)
     */
    filteredSearchTerm: {
      get() { return this.getFilteredSearchTerm },
    },
    /**
     * Filtro de fecha de recibida (filtro en store)
     */
    filteredReceivedDate: {
      get() { return this.getFilteredReceivedDate },
    },
    /**
     * Filtro de fecha de creación (filtro en store)
     */
    filteredCreatedAtDate: {
      get() { return this.getFilteredCreatedAtDate },
    },
    /**
     * Filtro de mes de recibida (filtro en store)
     */
    filteredReceivedMonth: {
      get() { return this.getFilteredReceivedMonth },
    },
    /**
     * Filtro de ubicación de piezas (filtro en store)
     */
    filteredPiecesLocation: {
      get() { return this.getFilteredPiecesLocation },
    },
    /**
     * Estatus de comisión global (filtro en store)
     */
    filteredCommissionStatus: {
      get() { return this.getFilteredCommissionStatus },
    },
    /**
     * Filtro de estatus de pago de reembolso (filtro en store)
     */
    filteredRefundPaymentStatus: {
      get() { return this.getFilteredRefundPaymentStatus },
    },
    /**
     * Determina si se puede mostrar el filtro de estatus de comisión
     */
    canShowCommissionStatusFilter() {
      const roles = ['Administrador', 'Encargado de Facturacion', 'Vendedor', 'Mayorista']
      return roles.includes(this.userData.Role)
    },
  },

  /**
  * Carga información del estado
  *
  * @summary Si existe información relacionada con los filtros cargados en el store,
  * se cargan en el componente
  */
  mounted() {
    // Carga el término de búsqueda (filtro en store)
    if (this.filteredSearchTerm) {
      this.$refs['basic-searcher'].loadSearchTerm(this.filteredSearchTerm)
    }

    // Carga la fecha de creación (filtro en store)
    this.selectedTransferDate = this.filteredCreatedAtDate || ''
    this.$watch('selectedTransferDate', date => {
      this.$emit('on:filter', { type: 'date', value: date })
    })

    // Carga el ordenamiento (filtro en store)
    this.selectedIdOption = this.filteredSortBy ? { text: this.filteredSortBy } : ''
    this.$watch('selectedIdOption', idOption => {
      this.$emit('on:filter', { type: 'sort', value: idOption !== null ? idOption.text : '' })
    })

    // Carga el estatus (filtro en store)
    this.selectedRefundStatus = this.filteredStatus ? { text: this.filteredStatus } : ''
    this.$watch('selectedRefundStatus', status => {
      this.$emit('on:filter', { type: 'status', value: status !== null ? status.text : '' })
    })

    // Carga el creador (filtro en store)
    this.selectedCreator = this.filteredCreator ? { item: this.filteredCreator } : ''
    this.$watch('selectedCreator', creator => {
      this.$emit('on:filter', { type: 'creator', value: creator !== null ? creator.item : '' })
    })

    // Carga la ubicación de piezas (filtro en store)
    this.selectedRefundLocation = this.filteredPiecesLocation ? { text: this.filteredPiecesLocation } : ''
    this.$watch('selectedRefundLocation', location => {
      this.$emit('on:filter', { type: 'location', value: location !== null ? location.text : '' })
    })

    // Carga el estatus de comisión (filtro en store)
    this.selectedCommissionStatus = this.filteredCommissionStatus ? { text: this.filteredCommissionStatus } : ''
    this.$watch('selectedCommissionStatus', status => {
      this.$emit('on:filter', { type: 'commission-status', value: status !== null ? status.text : '' })
    })

    // Carga el estatus de pago de reembolso (filtro en store)
    this.selectedRefundPaymentStatus = this.filteredRefundPaymentStatus ? { text: this.filteredRefundPaymentStatus } : ''
    this.$watch('selectedRefundPaymentStatus', status => {
      this.$emit('on:filter', { type: 'refund-payment-status', value: status !== null ? status.text : '' })
    })

    // Carga la fecha de recibida (filtro en store)
    this.selectedReceivedDate = this.filteredReceivedDate || ''
    this.$watch('selectedReceivedDate', date => {
      this.$emit('on:filter', { type: 'received-date', value: date })
    })

    // Carga el mes de recibida (filtro en store)
    this.selectedReceivedMonth = this.filteredReceivedMonth ? this.$moment(this.filteredReceivedMonth) : ''
    this.$watch('selectedReceivedMonth', month => {
      this.$emit('on:filter', { type: 'received-month', value: month !== null ? month.format('YYYY-MM-DD') : '' })
    })
  },

  methods: {
    /**
    * Evento del buscador básico
    * @summary Emite un evento con el término de búsqueda y limpia los campos de selección
    * @param {String} searchTerm - Término de búsqueda
    */
    handleSearch(searchTerm) {
      this.$emit('on:filter', { type: 'search', value: searchTerm })

      this.selectedCreator = null
      this.selectedIdOption = ''
      this.selectedTransferDate = ''
      this.selectedRefundStatus = ''
      this.selectedReceivedDate = ''
      this.selectedReceivedMonth = ''
      this.selectedRefundLocation = ''
      this.selectedCommissionStatus = ''
      this.selectedRefundPaymentStatus = ''
    },

    /**
    * Evento de cambio de nombre de creador
    * @summary Emite un evento cuando se ingresan caracteres en el buscador de creador
    * @param {String} text - Término de búsqueda
    */
    onCreatorNameChange(text) {
      if (text === '' || text === undefined) {
        this.creatorsOptions = []
        this.$emit('on:filter', { type: 'creator', value: '' })
        return
      }

      const filteredData = this.getCreatorsSuggests
        .filter(item => `${item.Name} ${item.LastName}`.toLowerCase().indexOf(text.toLowerCase()) > -1)
        .slice(0, this.limit)

      const namedSuggests = []

      filteredData.forEach(item => {
        namedSuggests.push({ name: `${item.Name} ${item.LastName || ''}`, id: item.IdUser })
      })
      this.creatorsOptions = [{
        data: namedSuggests,
      }]
    },
    onSelectedCreatorName(item) {
      this.selectedCreator = item
    },
  },
}
</script>

<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import '@core/scss/vue/libs/vue-autosuggest.scss';
  .style-chooser {
    background: #ffffff;
  }
</style>
